import React from "react";
import EPostaLogo from "../../layout/header/ePosta-logo.png";
import DitLogo from "../../layout/header/dokit-logo.png";
import ZeleniPostaLogo from "../../layout/header/posta_logo_zeleni.png";
import LogoHkms from "../../layout/header/logo-hkms.png";

export const themes = {
  yellow: {
    themeColor: "yellow",
    fontFamily: "Graublau",
    navColor: "black",
    navText: "white",
    navLinkColor: "black",
    cityClass: "location-active",
    calendar: "warning",
    lineColor: "warning",
    iconColor: "warning",
    logo: EPostaLogo,
    footer: true,
    footerVersion: "v1",
  },
  blue: {
    themeColor: "blue",
    fontFamily: "Museo",
    navColor: "white",
    navText: "black",
    navLinkColor: "white",
    cityClass: "location-active-blue",
    calendar: "info",
    lineColor: "black",
    iconColor: "info",
    logo: DitLogo,
    footer: false,
    footerVersion: "v1",
  },
  green: {
    themeColor: "primary-light",
    fontFamily: "Graublau",
    navColor: "white",
    navText: "black",
    navLinkColor: "black",
    cityClass: "location-active-blue",
    calendar: "primary",
    lineColor: "primary-light",
    iconColor: "primary",
    logo: ZeleniPostaLogo,
    footer: true,
    footerVersion: "v2",
  },
  purple: {
    themeColor: "purple",
    fontFamily: "Museo",
    navColor: "white",
    navText: "black",
    navLinkColor: "black",
    cityClass: "location-active-blue",
    lineColor: "purple-light",
    footerLineColor: "purple",
    iconColor: "purple-dark",
    calendar: "black",
    hrLine: "purple-dark",
    logo: LogoHkms,
    footer: true,
    footerVersion: "v2",
    tableSeparatorLine: "grey",
    tableSeparatorLineDark: "grey-darker",
    purpleCircle: "purple-1",
    purpleWarning: "purple-warning",
    voteGreen: "vote-green",
    voteRed: "vote-red",
    voteGrey: "vote-grey",
  },
};

export const ThemeContext = React.createContext(themes.purple);
